
interface PermissionMap {
    [roleName: string]: string[];
  }

const _PERMISSIONS : PermissionMap = {
    'root' : ['user:write', 'user:read', 'user:delete',
              'platform:write','platform:read', 'platform:delete',
              'package:write', 'package:read', 'package:delete'],
    'admin' : ['user:write', 'user:read', 'user:delete',
               'platform:write','platform:read', 'platform:delete',
               'package:write', 'package:read', 'package:delete'],
    'maintainer' : [ 'platform:write','platform:read', 'platform:delete',
                     'package:write', 'package:read', 'package:delete',],
    'reporter' : [ 'platform:read', 'package:read',],
    'pending' : ['none'],
    'device' : [ 'device:log', 'package:read' , 'platform:read']
}

export class User  {

    first: string = '';
    last: string = '';
    first_name: string = '';
    last_name: string = '';
    username: string = '';
    email: string = '';
    organization: string = '';
    school?: string = '';
    role: string = '';
    permissions: string[] = [];
    id: string = '';
    type: string = 'user';


    constructor( userResp?: any, config?: any) {


        if(userResp != undefined )
        {
            this.id = userResp.id;
            this.first = userResp.first || userResp.first_name || '';
            this.last = userResp.last || userResp.last_name || '';
            this.first_name = userResp.first_name || userResp.first || '';
            this.last_name = userResp.last_name || userResp.last || '';
            this.email = userResp.email;
            this.organization = userResp.organization || '';
            this.school = userResp.school || '';
            this.role = userResp.role;

            if(userResp.username != undefined)
            {

                this.username = userResp.username;
            }
            else 
            {
                this.username = `${this.first.toLowerCase()}.${this.last.toLowerCase()}`;
            }

            if(config != undefined)
            {
                this.permissions = config.roles.find((role: any) => role.name == this.role).permissions;
            }
            else
            {
                this.permissions = _PERMISSIONS[this.role];

            }

        }

    }

    isAdmin(){
        return this.role == 'admin' || this.role == 'root';
    }

    isAdminOrMaintainer(){
        return this.role == 'admin' || this.role == 'root' || this.role == 'maintainer';
    }

    isRoot(){
        return this.role == 'root';
    }

    hasPermission(permission: string) {
        return this.permissions.includes(permission);
    }

    getDisplayName(): string {
        if (this.username) {
            return this.username;
        }
        const firstName = this.first_name || this.first || '';
        const lastName = this.last_name || this.last || '';
        return `${firstName} ${lastName}`.trim() || this.email || 'Unknown User';
    }

}